import React, { useState } from "react";

const SelletTypeContents = [
  {
    img: require("../../../assets/BuyerProfile/StoreManager/SellerType/Manufacturer.png"),
    content: "Manufacturer",
  },
  {
    img: require("../../../assets/BuyerProfile/StoreManager/SellerType/Distributor.png"),
    content: "Distributor",
  },
  {
    img: require("../../../assets/BuyerProfile/StoreManager/SellerType/wholesaler.png"),
    content: "Wholesaler",
  },
  {
    img: require("../../../assets/BuyerProfile/StoreManager/SellerType/Retailer.png"),
    content: "Retailer",
  },
];

const SellerType = ({ sellerType, setSellerType, typeError, setTypeError }) => {
  
  const handleSellerType = (type) => {
    setSellerType(type);
  };

  return (
    // <div className="w-full h-[800px] flex items-center justify-center">
    <div className="w-[959px] h-[480px] rounded-[20px] bg-white flex flex-col items-center justify-start">
      <div className="w-[283px] h-[30px] flex flex-row items-center justify-between">
        <img
          src={require("../../../assets/BuyerProfile/StoreManager/SellerType/Naayatrade Final Logo File 1.jpg")}
          alt=""
          className="w-[24px] h-[30px]"
        />
        <p className="w-[250px] h-[27px] font-semibold text-[18px] text-[#FF6300]">
          Welcome to Store Manager
        </p>
      </div>

      <p className="w-[839px] h-[24px] font-semibold text-[16px] text-black mt-[19px]">
        Efficiently manage your products, orders, inquiries, and payments all in
        one place with - Store Manager
      </p>
      <p className="w-[235px] h-[21px] font-semibold text-[14px] text-black mt-[37px]">
        Select what type of seller you are
      </p>

      <div className="w-[959px] h-[239px] gap-x-[21px] flex flex-row mt-[24px]">
        {SelletTypeContents.map((item) => (
          <div key={item.content}>
            <button
              className={`w-[224px] h-[239px] border rounded-[10px] flex flex-col gap-y-[55px] items-center justify-center ${
                sellerType === item.content
                  ? "border-[#FF6300] border-[3px]"
                  : "bg-white"
              }`}
              onClick={() => {
                handleSellerType(item.content);
                setTypeError("");
              }}
            >
              <p className="w-[101px] h-[101px] rounded-full bg-[#F8F8F8] flex items-center justify-center">
                <img src={item.img} alt="" />
              </p>
              <p className="w-[100px] h-[21px] text-center font-semibold text-[14px] text-black">
                {item.content}
              </p>
            </button>
          </div>
        ))}
      </div>
        {typeError && <p className="text-red-400 mt-4">{typeError}</p>}
    </div>
    // </div>
  );
};

export default SellerType;
